/**
 * className 拼接（clsx 的最小替代，不引入依赖）。
 *
 * 只做一件事：丢掉 false / null / undefined / 空串，然后用单个空格连接。
 * 不解析对象、不做去重——需要条件类名时直接传 `cond && 'x'` 就够了，
 * 这也是本项目唯一用到的形式。
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === 'string' && part.length > 0).join(' ');
}
